import * as React from "react";
import Spinner from "../common/Spinner";
import { Card, Tabs, Tab, Row, Col, Badge } from "react-bootstrap";
import "../../css/Gifs.css";

export default class GIFS extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      gifs: []
    };
  }

  componentDidMount() {
    this.fetchGifs("trending");
  }

  fetchGifs = value => {
    const apiKey = "n58D56y56dhEn5KOdpi2hU02dcKf4hWj";
    let url;
    if ("trending" === value) {
      url = `https://api.giphy.com/v1/gifs/trending?api_key=${apiKey}&limit=25`;
    } else {
      url = `https://api.giphy.com/v1/gifs/search?q=${value}&api_key=${apiKey}&limit=25`;
    }
    (async () => {
      let response = await fetch(url);
      let gifs = await response.json();
      this.setState({ gifs: gifs.data });
    })();
  };

  searchGIF = event => {
    if (event.key === "Enter" && event.target.value) {
      this.fetchGifs(event.currentTarget.value);
    }
  };

  render() {
    if (this.state.gifs && this.state.gifs.length === 0) {
      return <Spinner />;
    } else {
      return (
        <div className="gifs-trends">
          <h1>GIFS</h1>
          <div className="search-container">
            <input
              type="text"
              id="search-bar"
              placeholder="search GIF"
              onKeyPress={this.searchGIF}
            />
            <i className="fas fa-search search-icon" />
          </div>
          <hr />
          {this.state.gifs.map((gif, index) => {
            return (
              <Card className="gifsCard" key={index}>
                <Card.Body>
                  <Tabs
                    defaultActiveKey="trending"
                    id="uncontrolled-tab-example"
                    className="bold"
                  >
                    <Tab eventKey="trending" title="Trending" className="gifs">
                      <Row>
                        <Col sm={12} md={12}>
                          <img
                            src={gif.images.preview_gif.url}
                            variant="top"
                            className="gifImage"
                            alt=""
                          />
                          <Badge pill variant="info" className="newsBadge">
                            {gif.title}
                          </Badge>
                        </Col>
                      </Row>
                    </Tab>
                  </Tabs>
                </Card.Body>
              </Card>
            );
          })}
          <strong>
            Source & Thanks to:
            <a href="https://developers.giphy.com/">GIPHY API</a>
          </strong>
        </div>
      );
    }
  }
}
